// extracted by mini-css-extract-plugin
export var flat = "home-module--flat--897e5";
export var glacier = "home-module--glacier--e1f97";
export var googleMap = "home-module--google-map--35629";
export var hill = "home-module--hill--ae667";
export var homeHeading = "home-module--home-heading--5ab09";
export var homeHow = "home-module--home-how--3bdc7";
export var homeWhat = "home-module--home-what--3b04b";
export var howBox = "home-module--how-box--b874c";
export var mountain = "home-module--mountain--dacbe";